import logo from "@/assets/logo.png";
import { cn } from "@/lib/utils";

interface AppLogoProps {
  size?: string;
  className?: string;
}

export function AppLogo({ size = "h-8 w-8", className }: AppLogoProps) {
  return (
    <img
      src={logo}
      alt="Maester logo"
      className={cn(size, "rounded-lg object-contain", className)}
    />
  );
}
